"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _distributionAlliance = require("@/api/distributionAlliance");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AllianceDistributionProduct',
  data: function data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        merId: null,
        keywords: ''
      },
      // 平台级淘客配置（mer_id=0）。保存要整条回传，所以原样留着读回来的对象
      config: null,
      zoneRewardShow: 1,
      configSaving: false
    };
  },
  created: function created() {
    this.loadConfig();
    this.load(1);
  },
  methods: {
    /** 平台级淘客配置。没配过时后端回 null，按「展示」处理，与加开关之前的行为一致 */loadConfig: function loadConfig() {
      var _this = this;
      (0, _distributionAlliance.getDistributionConfig)(0).then(function (res) {
        var data = (res && res.data !== undefined ? res.data : res) || null;
        _this.config = data;
        _this.zoneRewardShow = data && Number(data.zoneRewardShow) === 0 ? 0 : 1;
      }).catch(function () {});
    },
    /** 开关是即时生效的，不额外放一个「保存」按钮 —— 一个开关配一个保存键太重 */saveZoneRewardShow: function saveZoneRewardShow(value) {
      var _this2 = this;
      this.configSaving = true;
      var payload = _objectSpread(_objectSpread({}, this.config || {
        merId: 0
      }), {}, {
        merId: 0,
        zoneRewardShow: value
      });
      (0, _distributionAlliance.saveDistributionConfig)(payload).then(function () {
        _this2.config = payload;
        _this2.$message.success(value === 1 ? '已开启奖励金额展示' : '已关闭奖励金额展示');
      }).catch(function () {
        // 存失败就把开关拨回去，不然界面显示的是一个并没有生效的状态
        _this2.zoneRewardShow = value === 1 ? 0 : 1;
      }).finally(function () {
        _this2.configSaving = false;
      });
    },
    load: function load(page) {
      var _this3 = this;
      if (page) this.query.page = page;
      this.loading = true;
      (0, _distributionAlliance.getPlatformDistributionProducts)(this.query).then(function (res) {
        _this3.list = (res.list || res.records || []).map(_this3.normalize);
        _this3.total = Number(res.total || 0);
      }).finally(function () {
        _this3.loading = false;
      });
    },
    /**
     * 归一化列名。
     *
     * 后端这个查询的 resultType 是 Map，返回的键是 SQL 里的列名（下划线），
     * mybatis 的 map-underscore-to-camel-case 只作用于 POJO 映射，对 Map 不生效。
     * 商户端 distribution/goods 页里那些 `row.productId || row.product_id`
     * 就是同一个坑。集中转一次，模板里只认一套字段名。
     */
    normalize: function normalize(row) {
      var pick = function pick() {
        for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
          keys[_key] = arguments[_key];
        }
        for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
          var k = _keys[_i];
          if (row[k] !== undefined && row[k] !== null && row[k] !== '') return row[k];
        }
        return '';
      };
      return {
        id: pick('id'),
        merId: pick('merId', 'mer_id'),
        merName: pick('merName', 'mer_name'),
        productId: pick('productId', 'product_id'),
        productName: pick('productName', 'product_name'),
        image: pick('image'),
        price: pick('price'),
        sales: pick('sales') || 0,
        stock: pick('stock') || 0,
        shareRewardType: pick('shareRewardType', 'share_reward_type'),
        shareRewardValue: pick('shareRewardValue', 'share_reward_value'),
        partnerRewardType: pick('partnerRewardType', 'partner_reward_type'),
        partnerRewardValue: pick('partnerRewardValue', 'partner_reward_value'),
        commissionOpen: Number(pick('commissionOpen', 'commission_open') || 0),
        createTime: pick('createTime', 'create_time'),
        // 限定了几个规格；0 表示整品参加
        scopeCount: function () {
          var scope = pick('attrValueIds', 'attr_value_ids');
          return scope ? String(scope).split(',').filter(function (v) {
            return v.trim();
          }).length : 0;
        }()
      };
    },
    onSizeChange: function onSizeChange(size) {
      this.query.limit = size;
      this.load(1);
    },
    reset: function reset() {
      this.query = {
        page: 1,
        limit: this.query.limit,
        merId: null,
        keywords: ''
      };
      this.load(1);
    },
    /**
     * 单品奖励。type：1-佣金(元) 2-积分 3-佣金(%)（见 DistributionProduct 的 shareRewardType）。
     * 命中这一层后 CommissionRuleService 直接返回，不再往下取全局比例。
     * 比例口径存的是百分比，结算时才按佣金基数折算，所以这里只能显示百分比本身。
     */
    rewardText: function rewardText(type, value) {
      var n = Number(value || 0);
      if (!n) return '-';
      if (Number(type) === 2) return n + ' 积分';
      return Number(type) === 3 ? n.toFixed(2) + '%' : '¥' + n.toFixed(2);
    },
    toggle: function toggle(row) {
      var _this4 = this;
      var open = row.commissionOpen === 1 ? 0 : 1;
      var action = open === 1 ? '重新开启' : '强制关闭';
      this.$confirm("\u786E\u5B9A".concat(action, "\u300C").concat(row.merName || row.merId, "\u300D\u7684\u5546\u54C1\u300C").concat(row.productName, "\u300D\u7684\u6DD8\u5BA2\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        return (0, _distributionAlliance.togglePlatformDistributionProduct)(row.id, open);
      }).then(function () {
        _this4.$message.success(action + '成功');
        _this4.load();
      }).catch(function () {});
    }
  }
};